import type { GetRequestsListItem } from "@nlc/shared-types";

import { whitelabelRowClassName } from "@/features/requests/constants/accountTags";

import type { TableConfig } from "../../../types/tables";

import { TABLE_LAYOUT_PRESETS } from "../../constants/columnWidths";
import { accountTagsCell } from "../../helpers/accountTagsCell";
import {
  inlineAssigneeCell,
  inlineBrandCell,
} from "../../helpers/cellRenderers";
import {
  accountCellWithSlotTooltip,
  dateCell,
  designTypeCell,
  nameCell,
} from "../../helpers/commonCells";
import { renderRating } from "../../helpers/renderHelpers";

// Completed Tab Configuration for Team Lead "Assigned to Me"
// Columns: Name, Account, Brand, Assignee, Created by, Completed date, Rating, Request/Design type, Tags
export const teamleadCompletedTableConfig: TableConfig<GetRequestsListItem> = {
  columns: [
    {
      accessor: "name",
      cellRenderer: nameCell,
      header: "Name",
      key: "name",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.name,
    },
    {
      accessor: "account",
      cellRenderer: accountCellWithSlotTooltip,
      header: "Account",
      key: "account",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.account,
    },
    {
      accessor: "brand",
      cellRenderer: inlineBrandCell,
      header: "Brand",
      key: "brand",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.brand,
    },
    {
      accessor: "assignee",
      cellRenderer: inlineAssigneeCell,
      header: "Assignee",
      key: "assignee",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.assignee,
    },
    {
      accessor: "completedDate",
      cellRenderer: dateCell,
      header: "Completed date",
      key: "completedDate",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.completedDate,
    },
    {
      accessor: "rating",
      cellRenderer: (value: unknown) =>
        renderRating(value as null | number | undefined),
      header: "Rating",
      key: "rating",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.rating,
    },
    {
      accessor: "designType",
      cellRenderer: designTypeCell,
      header: "Design Type",
      key: "designType",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.requestType,
    },
    {
      accessor: "account",
      cellRenderer: accountTagsCell,
      header: "Tags",
      key: "accountTags",
      sortable: false,
      width: 150,
    },
  ],
  defaultSort: {
    column: "completedDate",
    direction: "desc",
  },
  enableSorting: true,
  getRowClassName: whitelabelRowClassName,
  id: "teamlead-completed-requests",
  title: "Completed Requests",
};
